import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// crm_lead_sources — แหล่งที่มาของลีด
// ============================================================================
export const crmLeadSources = sqliteTable("crm_lead_sources", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  sortOrder: integer("sort_order").default(0),
  isActive: integer("is_active").default(1),
});

// Type exports
export type CrmLeadSource = typeof crmLeadSources.$inferSelect;
export type NewCrmLeadSource = typeof crmLeadSources.$inferInsert;
